import React, { useState } from 'react';
import ScrollReveal from '../components/ScrollReveal';
import { useLanguage } from '../i18n/LanguageContext';

export default function Contact() {
  const { t } = useLanguage();
  const c = t.contact;
  const [status, setStatus] = useState('idle'); // idle | sending | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);
    const params = new URLSearchParams();
    for (const [key, value] of formData.entries()) {
      params.append(key === 'solution' ? 'service' : key, value);
    }

    setStatus('sending');
    try {
      const res = await fetch('/sendmail.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const data = await res.json();
      if (!res.ok || data.status !== 'success') {
        throw new Error(data.message || 'Failed to send enquiry.');
      }
      setStatus('success');
      form.reset();
      setTimeout(() => setStatus('idle'), 5000);
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <section id="contact" className="page-section bg-dark">
      <div className="container">
        <div className="contact-grid">
          <ScrollReveal>
            <span className="section-eyebrow contact-eyebrow">{c.eyebrow}</span>
            <div className="accent-line" />
            <h2 className="section-title contact-section-title">{c.title}</h2>
            <p className="section-sub contact-section-sub">{c.sub}</p>
            <div className="contact-info-list">
              {c.items.map(item => (
                <div key={item.label} className="contact-info-item">
                  <div className="ci-icon">{item.icon}</div>
                  <div>
                    <div className="ci-label">{item.label}</div>
                    <div className="ci-value" style={{ whiteSpace:'pre-line' }}>{item.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </ScrollReveal>

          <ScrollReveal delay={80}>
            <div className="contact-form">
              <div className="form-title">{c.formTitle}</div>
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>{c.labels.name}</label>
                    <input type="text" name="name" placeholder={c.placeholders.name} required />
                  </div>
                  <div className="form-group">
                    <label>{c.labels.company}</label>
                    <input type="text" name="company" placeholder={c.placeholders.company} />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>{c.labels.email}</label>
                    <input type="email" name="email" placeholder={c.placeholders.email} required />
                  </div>
                  <div className="form-group">
                    <label>{c.labels.phone}</label>
                    <input type="tel" name="phone" placeholder={c.placeholders.phone} />
                  </div>
                </div>
                <div className="form-group">
                  <label>{c.labels.solution}</label>
                  <select name="solution" defaultValue="">
                    <option value="">{c.placeholders.solution}</option>
                    {c.solutions.map(s => <option key={s}>{s}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>{c.labels.message}</label>
                  <textarea name="message" placeholder={c.placeholders.message} />
                </div>
                {status === 'error' && (
                  <p style={{ color: '#ff6b6b', fontSize: '13.5px', marginBottom: '16px' }}>
                    {c.errorMsg}
                  </p>
                )}
                <button
                  type="submit"
                  disabled={status === 'sending'}
                  className={`btn-submit${status === 'success' ? ' success' : ''}`}
                >
                  {status === 'sending' && c.sendingBtn}
                  {status === 'success' && c.successMsg}
                  {(status === 'idle' || status === 'error') && c.sendBtn}
                </button>
              </form>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
